<template>
  <v-app class="custom_bg">
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <div>
            <p class="text-h2">Your licence has expired!</p>
          </div>
          <div>
            <p class="text-body-1">
              Kindly contact <a >receipt@drecsoft.com</a> or visit
              <a href=""> www.drecsoft.com</a> to renew your licence
            </p>
          </div>
          <div>
            <p class="text-body-1">Thank you</p>
          </div>
          <div class="my-8">
            <v-btn color="primary" width="300" to="/"
              >go back to login page</v-btn
            >
          </div>
          <div>
            <v-btn color="primary" width="300" :href="getSub"
              >make subscription payment</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["getSub"]),
  },
};
</script>
<style scoped>
.custom_bg {
  background: #f6f7ff;
}
</style>